// extracted by mini-css-extract-plugin
export default {"-large":"mADcmf_sLRGj2gJXLmHo","customSpacingMR6":"pxPMkAiLzP_QtQgUbxM_","recentLocationRow":"K_D4S2ldc8U6ECERa4zb"};